import { ComponentType } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import { WindowComponent } from './window.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class WindowService {

  constructor(
    private dialog: MatDialog,
    private snackBar: MatSnackBar
  ) { }

  open(winConfig: WindowConfig) {
    const titleSnackBar = $localize`Close the opened window before`;
    const config = createConfig(winConfig.config);
    const opened = this.getRef(config.id);
    if (opened) {
      this.snackBar.open(titleSnackBar, null, { duration: 2000 });
      const w = opened.componentInstance as WindowComponent;
      w.letsShakeIt();
      return;
    }

    const dialogRef = this.dialog.open(WindowComponent, config);
    dialogRef.componentInstance.component = winConfig.componentType;
    dialogRef.componentInstance.title = winConfig.title;
    dialogRef.componentInstance.help = winConfig.help;

    if (winConfig.position) {
      const { top, left } = winConfig.position;
      dialogRef.updatePosition({ top: `${top}px`, left: `${left}px` });
    }

    return dialogRef.afterClosed();
  }

  close(component: object) {
    const dialogRef = this.dialog.openDialogs.find(
      d => {
        const content = d.componentInstance.windowContentInstance;
        return content === component;
      }
    );
    dialogRef.close();
  }

  closeByClass(componentType: ComponentType<any>) {
    const dialogRef = this.dialog.openDialogs.find(
      d => {
        const content = d.componentInstance.component;
        return content === componentType;
      }
    );
    dialogRef.close();
  }

  findByClass(componentType: ComponentType<any>): MatDialogRef<any> {
    const dialogRef = this.dialog.openDialogs.find(
      d => {
        const content = d.componentInstance.component;
        return content === componentType;
      }
    );
    return dialogRef;
  }

  closeAll() {
    this.dialog.openDialogs.forEach(d => d.close());
  }

  isOpened(id: string) {
    return !!this.getRef(id);
  }

  private getRef(id: string) {
    return this.dialog.openDialogs.find((d) => d.id === id);
  }

}

export interface WindowConfig {
  title: string;
  componentType: ComponentType<any>;
  config?: MatDialogConfig;
  help?: string;
  position?: {
    top: number;
    left: number;
  };
}

const createConfig = (config: MatDialogConfig): MatDialogConfig => {
  return {
    id: 'UNIQUE_WINDOW_OPENED',
    ...config
  };
};

